import Vue from "vue";
import Router from "vue-router";
import { routes } from "@/router/config";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import {
  UPDATE_TOKEN,
  ADD_TOOLBAR_TITLE,
  CLEAR_ALL_MSG
} from "@/store/actions/actions.type";

Vue.use(Router);
const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: routes
});

// router guards
router.beforeEach((to, from, next) => {
  NProgress.start();
  Promise.all([
    store.dispatch(`auth/${UPDATE_TOKEN}`),
    store.dispatch(`application/${ADD_TOOLBAR_TITLE}`, to.meta.toolbarTitle)
  ])
    .then(() => {
      Vue.toasted.clear();
      store.dispatch(`application/${CLEAR_ALL_MSG}`);
    })
    .then(next)
    .catch(e => {
      console.log(e);
    });
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
